// The bots' chances, from strings rather than a clock.
//
// A BOT'S DAY IS THE SAME DAY HOWEVER MANY TIMES IT IS RUN. A job that fails
// and runs again, a sweep catching up after an outage and a season replayed by
// the suite all ask the same questions, so every chance is a number drawn from
// a key that names what it is for — the league, the team, the day — and never
// from `Math.random`.

/** A number in [0, 1) that `key` alone decides: FNV-1a into one step of mulberry32. */
export function draw(key: string): number {
  let h = 2166136261;
  for (let i = 0; i < key.length; i += 1) {
    h ^= key.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  let a = ((h >>> 0) + 0x6d2b79f5) | 0;
  a = Math.imul(a ^ (a >>> 15), 1 | a);
  a = (a + Math.imul(a ^ (a >>> 7), 61 | a)) ^ a;
  return ((a ^ (a >>> 14)) >>> 0) / 4294967296;
}

/**
 * How far a bot's reading of one player's projection strays this week: a
 * factor around 1, within `noise` of it. Keyed by the week, so a casual bot's
 * misjudgment is the same misjudgment every day of that week rather than a
 * lineup that flips each morning.
 */
export function misreading(noise: number, key: string): number {
  return 1 + (draw(key) * 2 - 1) * noise;
}
